import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "ZERO WATER WASTAGE",
  "99.5% SOILING RECOVERY",
  "AUTONOMOUS ROBOTICS",
  "IOT CLOUD TELEMETRY",
  "UTILITY-SCALE O&M",
  "12–20 MONTH PAYBACK",
];

export const Ticker = () => (
  <div className="bg-helios-slate py-6 border-y border-white/10 relative overflow-hidden" data-testid="marquee">
    <div className="noise-overlay" />
    <Marquee speed={38} gradient gradientColor="#0F172A" gradientWidth={80}>
      {ITEMS.concat(ITEMS).map((t, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span className="font-display font-extrabold text-2xl md:text-4xl marquee-outline" style={{ WebkitTextStroke: "1.5px rgba(255,255,255,0.35)" }}>
            {t}
          </span>
          <span className="w-2 h-2 rounded-full bg-helios-amber" />
        </span>
      ))}
    </Marquee>
  </div>
);
